<template>
  <div>
    <div ref="component" class="simple cx_style">
      <div class="content-item">
        <div class="content flex">
          <div class="upload" :class="'img-size-' + size">
            <span v-show="imgVal" class="icon-portal-delete del-bg-icon" @click="delBgImage"></span>
            <img v-if="imgVal" :src="imgVal" name="uploadFile" />
            <span class="icon icon-portal-plus" v-if="!imgVal"></span>
            <input
              class="upload-btn"
              v-if="!imgVal"
              type="file"
              accept="image/gif,image/jpeg,image/jpg,image/png"
              @change="uploadImg($event)"
            />
          </div>
          <div class="text ml16">
            <div class="description mb2">格式：PNG/JPG/GIF</div>
            <div class="description mb2">大小：1M以下</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import defaultImgSrc from "../../assets/images/default_image.png"
import publicData from "../mixins/publicData.js"
import primaryImg from "assets/images/primaryImage.png"
import emptyImg from "assets/images/empty_img_bg.png"
import { uploadResources } from "../../utils"
import instance from "../../interceptor"
export default {
  mixins: [publicData],
  name: "imgUploadSimple",
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    defaultImg: {
      type: String,
      required: false
    },
    themeKey: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: "small",
      required: false
    }
  },
  data() {
    return {
      imgResDialogVisible: false,
      contextPath: "",
      classify: [],
      // wfwfid: undefined,
      imgList: [],
      noImg: true
    }
  },
  computed: {
    imgVal: {
      get() {
        return this.imgSrc
      },
      set(val) {
        this.$emit("update:imgSrc", val)
      }
    },
    wfwfid() {
      return this.$store.state.states.getDataPageIds.wfwfid
    }
  },
  mounted() {},
  methods: {
    uploadImg(e) {
      let file = e.target.files[0]
      let _this = this
      uploadResources(file, 5, this, function (imgSrc) {
        _this.imgVal = imgSrc
      })
    },
    delBgImage() {
      this.imgVal = ""
    },
    selectImage(image) {
      this.imgVal = image.url
    }
  }
}
</script>

<style scoped>
/*图片上传出的样式*/
.upload {
  position: relative;
  background: var(--inputBackGround);
  border-radius: 4px;
  cursor: pointer;
}
.upload .icon {
  font-size: 18px;
}
.upload .upload-btn {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0;
}
.upload .del-bg-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 10;
  cursor: pointer;
}
.content .img-size-small {
  width: 72px;
  height: 72px;
  line-height: 72px;
  text-align: center;
}
.content .img-size-medium {
  width: 90px;
  height: 90px;
  line-height: 90px;
  text-align: center;
}
.content .upload img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.content .upload .del-bg-icon {
  position: absolute;
  display: none;
  bottom: 4px;
  top: auto;
  right: 4px;
  z-index: 10;
  cursor: pointer;
  width: 18px;
  line-height: 18px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
}
.content .upload:hover .del-bg-icon {
  display: block;
}
.upload-btns input[type="file"] {
  width: 38px;
}
.upload-btns span {
  cursor: pointer;
}
.el-select:hover .el-input__inner {
  border: none;
}
.el-color-dropdown .el-input__inner {
  background: #f7f7f7;
}
.content .description {
  font-size: 12px;
  line-height: 17px;
}
.img-boxs > li {
  display: inline-block;
  vertical-align: top;
  margin: 10px;
}
.img-boxs img {
  width: 130px;
  height: 74px;
  box-sizing: border-box;
  cursor: pointer;
}
.img-boxs img:hover {
  border: 1px solid rgba(8, 140, 223, 1);
}
::v-deep .imgResDialog {
  width: 620px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid var(--borderColorFive);
}
::v-deep .imgResDialog .el-dialog__header {
  border-bottom: 1px solid var(--borderColorFive);
}
::v-deep .imgResDialog .el-dialog__body {
  overflow: hidden;
  padding: 10px 0 20px 10px;
  box-sizing: border-box;
  height: 397px;
}
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
  width: 110%;
  height: 100%;
}
::v-deep .scrollbar {
  height: 100%;
}
::v-deep .el-dialog__headerbtn {
  top: 12px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
}
.img-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}
.img-set-dialog-wrap .img-set-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  width: 210px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
}
.img-set-dialog-wrap .dialog-header {
  position: relative;
  padding: 9.5px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  height: 40px;
  line-height: 20px;
}
.img-set-dialog-wrap .dialog-header .dialog-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
}
.img-set-dialog-wrap .dialog-header .icon-portal-close {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.6);
}
.img-set-dialog-wrap .dialog-body {
  padding: 16px 12px;
  height: 300px;
  overflow-y: auto;
}
.img-set-dialog-wrap .dialog-body .img-title {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 20px;
}
.img-set-dialog-wrap .dialog-body .img-boxs {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
}
.img-set-dialog-wrap .dialog-body .img-boxs:last-child {
  margin-bottom: 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs > li {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 8px 0 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs > li:nth-child(4n) {
  margin-right: 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs img {
  width: 24px;
  height: 24px;
}
.img-set-dialog-wrap .dialog-body .img-boxs img:hover {
  border: none;
}
</style>
